import React from 'react';
import { IconProps } from '../types';
const MinecraftGoldenHelmet: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="3" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(234, 238, 87, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(233, 177, 21, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(220, 150, 19, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(130, 93, 22, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(63, 46, 14, 255)" />
</svg>);
export default MinecraftGoldenHelmet;